export default "__VITE_ASSET__0ebe0e47__"